import { useTranslation } from "react-i18next"
import { MILLISECONDS_IN_DAY, MILLISECONDS_IN_HOUR, MILLISECONDS_IN_MINUTE } from "@/lib/format-date"

const calculateTimeDifference = (
  currentTime: number,
  messageTime: number,
  messageDate: Date,
  { t }: ReturnType<typeof useTranslation>,
) => {
  const difference = currentTime - messageTime
  const now = new Date()
  const minutes = Math.floor(difference / MILLISECONDS_IN_MINUTE)
  const hours = Math.floor(difference / MILLISECONDS_IN_HOUR)
  const days = Math.floor(difference / MILLISECONDS_IN_DAY)
  const months = now.getMonth() - messageDate.getMonth()
  const years = now.getFullYear() - messageDate.getFullYear()

  if (minutes < 1) {
    return t("chat.duration.lessThanAMinute")
  } else if (minutes >= 1 && hours < 1) {
    return t("chat.duration.minuteOther", { count: minutes })
  } else if (hours >= 1 && days < 1) {
    return t("chat.duration.hourOther", { count: hours })
  } else if (days >= 1 && days < 30) {
    return t("chat.duration.dayOther", { count: days })
  } else if (months >= 1 && years < 1) {
    return t("chat.duration.monthOther", { count: months })
  } else {
    return t("chat.duration.yearOne", { count: years })
  }
}

export { calculateTimeDifference }
